var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,346.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5743,2377.1c-239.6-110.6-352.4-393.9-251.1-638c25.4-64.5,412.3-467.6,1386.6-1441.8l1352-1354.3H4335.7H440.9l-101.3-53c-55.3-29.9-131.3-99-170.4-152c-62.2-89.8-69.1-115.2-69.1-278.7c0-163.5,6.9-188.9,69.1-278.7c39.2-52.9,115.2-122.1,170.4-152l101.3-53h3894.8h3894.8l-1352-1354.3c-976.6-976.6-1361.2-1377.4-1386.6-1441.8c-172.7-421.5,262.6-826.9,667.9-624.2c87.5,43.8,520.6,465.3,1888.7,1835.7C9186.4-2469,9838.2-1798.7,9861.2-1743.4c55.3,117.5,50.7,301.7-9.2,421.5c-71.4,142.8-3593.1,3657.6-3715.2,3706C6019.4,2432.4,5855.9,2430.1,5743,2377.1z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRightArrow);
export default __webpack_public_path__ + "static/media/ico-right-arrow.8fb635cf54471732d1cec4826df61615.svg";
export { ForwardRef as ReactComponent };